import { Directive, OnInit, ElementRef, HostListener } from '@angular/core';

const eventTargetValue = '$event.target.value';

@Directive({
  selector: '[claimCodeFormat][claimCode][ngModel]'
})
export class ClaimCodeFormatter implements OnInit {
  el: HTMLInputElement;
  constructor(elementRef: ElementRef) {
    this.el = elementRef.nativeElement;
  }

  ngOnInit() {
    this.el.value = this.formatOutput(this.el.value);
  }

  formatOutput(codeInput) {
    if (!codeInput) {
      return codeInput;
    }
    try {
      return this.onClaimCodeInputKeyUp(codeInput);
    } catch (error) {
      return codeInput;
    }
  }

  onClaimCodeInputKeyUp(input) {
    // When user select text in the document, also abort.
    const selection = window.getSelection().toString();
    if (selection !== '') {
      return;
    }

    // When the arrow keys are pressed, abort.
    // if ([38, 40, 37, 39].indexOf(event.keyCode) !== -1) {
    //   return;
    // }

    input = input.replace(/[\s\._\- ]+/g, '');

    const split = 4,
      chunk = [];

    for (let i = 0, len = input.length; i < len; i += split) {
      chunk.push(input.substr(i, split));
    }
    return chunk.join(' ').toUpperCase();
  }

  @HostListener('focus', [eventTargetValue])
  onFocus(value) {
    this.el.value = this.formatOutput(value);
  }

  @HostListener('blur', [eventTargetValue])
  onBlur(value) {
    this.el.value = this.formatOutput(value);
  }

  @HostListener('keyup', [eventTargetValue])
  onKeyUp(value) {
    this.el.value = this.formatOutput(value);
  }
}
